var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "single_question" },
    [
      _c("div", { staticClass: "question_title" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.questionData.sectionName === undefined
                ? ""
                : _vm.questionData.sectionName
            )
          )
        ]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "(" +
              _vm._s(
                _vm.questionData.sectionPrompt +
                  "  本题" +
                  _vm.questionData.score +
                  "分。"
              ) +
              ")"
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "title" }, [
        _vm.questionData.questionContent
          ? _c("div", {
              staticClass: "editorShowArea ql-editor title_one",
              domProps: { innerHTML: _vm._s(_vm.questionData.questionContent) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("h3", {
          staticClass: "editorShowArea ql-editor",
          staticStyle: { overflow: "auto" },
          domProps: {
            innerHTML: _vm._s(_vm.questionData.questionDto.questionContent)
          }
        })
      ]),
      _vm._v(" "),
      _vm._l(_vm.questionData.questionDto.items, function(data, index) {
        return _c(
          "div",
          { key: index, staticClass: "single_item" },
          [
            _c(
              "el-radio",
              {
                staticClass: "single_radio",
                attrs: { label: data.itemKey, disabled: _vm.disabledFlag },
                on: { change: _vm.save },
                model: {
                  value: _vm.radio,
                  callback: function($$v) {
                    _vm.radio = $$v
                  },
                  expression: "radio"
                }
              },
              [_vm._v(_vm._s(null))]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "single_title",
                staticStyle: { float: "left", "margin-top": "15px" }
              },
              [_vm._v(_vm._s(data.itemKey))]
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "single_title editorShowArea ql-editor",
              domProps: { innerHTML: _vm._s(data.itemValue) }
            })
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c3be635", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c3be635","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/testComponent/single.vue
// module id = null
// module chunks = 